// CREDENTIALS FORM
export const UPDATE_TOGGLE_CREDENTIALS_FORM = "UPDATE_TOGGLE_CREDENTIALS_FORM";
export const UPDATE_CREDENTIALS_FORM_DATA = "UPDATE_CREDENTIALS_FORM_DATA";
export const UPDATE_IS_VALID_CREDENTIALS_FORM = "UPDATE_IS_VALID_CREDENTIALS_FORM";

// SNACKBAR NOTIFIER
export const UPDATE_SNACKBAR_NOTIFIER = "UPDATE_SNACKBAR_NOTIFIER";